import React, { useState, useRef, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { FaUserCircle } from 'react-icons/fa';
import { FaHome } from 'react-icons/fa';
import './UserMenu.css';

const UserMenu = () => {
  const { currentUser, logout, isAdmin } = useAuth();
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const navigate = useNavigate();

  // Gérer le clic en dehors du menu pour le fermer
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleLogout = async () => {
    try {
      await logout();
      navigate('/');
    } catch (error) {
      console.error('Erreur lors de la déconnexion:', error);
    }
  };

  const handleDashboard = () => {
    navigate(isAdmin ? '/admin' : '/mon-compte');
    setIsOpen(false);
  };

  return (
    <div className="user-menu-container" ref={menuRef}>
      <button 
        className="user-menu-button" 
        onClick={() => setIsOpen(!isOpen)}
        aria-label="Menu utilisateur"
      >
        {currentUser?.avatar ? (
          <img 
            src={currentUser.avatar} 
            alt="Profil" 
            className="user-avatar"
          />
        ) : (
          <FaUserCircle className="user-icon" />
        )}
      </button>
      
      {isOpen && (
        <div className="user-dropdown">
          <div className="user-info">
            <p className="user-name">{currentUser?.name || 'Utilisateur'}</p>
            <p className="user-email">{currentUser?.email}</p>
          </div>
          
          <button 
            className="dropdown-item"
            onClick={handleDashboard}
          >
            {isAdmin ? (
              <>
                <FaHome className="dropdown-icon" />
                Tableau de bord
              </>
            ) : (
              'Mon compte'
            )}
          </button>
          
          <button 
            className="dropdown-item logout"
            onClick={handleLogout}
          >
            Déconnexion
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
